import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DownloadUtilService {
  public downloadCsvFile(data: string, name: string) {
    const blob = new Blob(['\uFEFF' + data], { type: 'text/csv' });

    this.downloadBlob(blob, name);
  }

  public downloadBlob(blob: Blob, name: string) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
}
